export default function () {
  this.doLoadItem('me')
}



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/form/resources/mounted.js